// Shared test_id -> human-readable display name map. Originally defined
// only inside MyPatients.js (2026-10-12 fix for raw codes like
// "tox_placeholder_1" showing on the clinician-facing order history view).
// Extracted here (2026-10-13) so PatientConsent.js — the PATIENT-facing
// signing page, where a raw internal placeholder code is an even worse
// bug than on the clinician's own view — can reuse the exact same map
// instead of drifting a second, hand-typed copy. Mirrors the display names
// seeded server-side in labariumaiportal/backend/main.py's
// orderable_tests_collection seed list (~line 759-796). Falls back to the
// raw id for anything not in this list (e.g. a test added server-side
// after this map was last synced) rather than hiding it.
export const TEST_ID_DISPLAY_NAMES = {
  proove_pgx: "Proove Drug Metabolism™ Profile (PGx)",
  proove_opioid_risk: "Proove Opioid Risk™ Profile",
  proove_pain_perception: "Proove Pain Perception™ Profile",
  tox_placeholder_1: "Toxicology Screening Panel",
  tox_placeholder_2: "Toxicology Confirmation Panel",
  id_molecular_placeholder_1: "Infectious Disease / Molecular PCR Panel",
  id_molecular_placeholder_2: "Infectious Disease Reference Culture",
};

// Human-readable family labels — mirrors OrderTest.js's FAMILY_LABELS /
// MyPatients.js's ORDER_FAMILY_LABELS (byte-identical set, kept here too
// so PatientConsent.js doesn't fall back to a raw schema_key for the
// family chip either).
export const TEST_FAMILY_DISPLAY_NAMES = {
  proove: "Proove",
  toxicology: "Toxicology",
  infectious_disease_molecular: "Infectious Disease / Molecular PCR",
};

export function displayNameForTestId(testId) {
  return TEST_ID_DISPLAY_NAMES[testId] || String(testId || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function displayNameForFamily(family, schemaKey) {
  return TEST_FAMILY_DISPLAY_NAMES[family] || family || schemaKey || "Requisition";
}
